import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import service_studies from 'services/studies';

/** @typedef {number} UseHardDeleteStudyMutationVariables - Study ID */

/** @typedef {Omit<UseMutationOptions<{ message: string }, Error, UseHardDeleteStudyMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseHardDeleteStudyMutationOptions */

/**
 * @param {UseHardDeleteStudyMutationOptions} [options={}]
 */
export const useHardDeleteStudyMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['hard-delete-study'],
        /** @param {UseHardDeleteStudyMutationVariables} studyId */
        mutationFn: studyId => service_studies.hardDeleteStudy(studyId)
    });
};
